/** Security Trails card-aligned labels for derive_from stored on investigations. */
export const SECURITY_TRAILS_CARD_EDGE_LABEL = {
  IP_ADDRESS: 'IP Address',
  DOMAIN_ON_IP: 'Domain on IP',
  SUBDOMAIN: 'Subdomain',
  MX_RECORD: 'MX Record',
  DOMAIN_ON_NS: 'Domain on NS',
};

/** Edge labels when a node is added from SecurityTrails (Historical) DNS rows. */
export const SECURITY_TRAILS_HISTORICAL_EDGE_LABEL = {
  IP_ADDRESS: 'IP Address (Historical)',
  MX_RECORD: 'MX Record (Historical)',
  DOMAIN_ON_NS: 'Domain on NS (Historical)',
};

/** PublicWWW tab → chart edge. */
export const PUBLICWWW_EDGE_LABEL = 'PublicWWW Search';

/** Only UrlScan-derived rows — Search vs Scan (no Finding may reuse these). */
export function urlScanRowConnectionLabel(informationType) {
  if (!informationType) return null;
  if (informationType === 'URL_SEARCH') return 'URLScan Search';
  return 'URLScan Scan';
}
